import { ensureCsrfCookie, refreshCsrfToken } from './csrfService';
import { authFetch, FetchLikeResponse } from './fetchHelpers';
import { AuthUser } from '../types';
import { OAUTH_BASE_URL } from './config';

type HttpStatusError = Error & {
  status?: number;
};

const getRequiredOAuthBaseUrl = (): string => {
  if (!OAUTH_BASE_URL) {
    throw new Error('oath base url is required for Google OAuth login.');
  }
  return OAUTH_BASE_URL.replace(/\/$/, '');
};

export const getGoogleLoginUrl = (): string => {
  const base = getRequiredOAuthBaseUrl();
  return `${base}/oauth2/authorization/google`;
};

export const startGoogleLogin = (): void => {
  const loginUrl = getGoogleLoginUrl();
  window.location.assign(loginUrl);
};

const buildHttpErrorMessage = async (response: FetchLikeResponse): Promise<string> => {
  let errorMessage = `HTTP error! status: ${response.status}`;
  try {
    const errorBody = await response.json();
    errorMessage = errorBody.message || errorBody.error || JSON.stringify(errorBody) || errorMessage;
  } catch (e) {
    // Ignore if response body is not JSON or empty
  }
  return errorMessage;
};

export const fetchCurrentUser = async (): Promise<AuthUser> => {
  const response = await authFetch('/auth/me');
  if (!response.ok) {
    const errorMessage = await buildHttpErrorMessage(response);
    console.error('Failed to fetch current user:', errorMessage);
    const error: HttpStatusError = new Error(`Failed to fetch current user: ${errorMessage}`);
    error.status = response.status;
    throw error;
  }
  return response.json();
};

export const logout = async (): Promise<void> => {
  await ensureCsrfCookie();
  const response = await authFetch('/auth/logout', {
    method: 'POST',
  });
  if (!response.ok) {
    const errorMessage = await buildHttpErrorMessage(response);
    console.error('Failed to logout:', errorMessage);
    throw new Error(`Failed to logout: ${errorMessage}`);
  }
  await refreshCsrfToken();
};
